import { render, staticRenderFns } from "./KardexPage.vue?vue&type=template&id=cef59c8a&scoped=true&"
import script from "./KardexPage.vue?vue&type=script&lang=js&"
export * from "./KardexPage.vue?vue&type=script&lang=js&"
import style0 from "./KardexPage.vue?vue&type=style&index=0&id=cef59c8a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cef59c8a",
  null
  
)

export default component.exports


//////////////////
// WEBPACK FOOTER
// ./src/pages/information/KardexPage.vue
// module id = 212
// module chunks = 10